<!-- <div class="banner-container" [@slideInOut]>
    <img src="assets/img/icons8-sedan-ios-17-32.png" alt="Logo Auto" class="logo">
    <span class="phone-number">Chiamaci: 081-0608201</span>
  </div> -->

  <div class="banner">
    <!-- <p>Contattaci al numero: <strong>081 - 0608201</strong></p> -->
    <span>Chiamaci: 081-0608201</span>
    <img src="assets/img/icons8-sedan-ios-17-32.png" alt="Automobile">
  </div>